import { render, staticRenderFns } from "./ProfileRemovalInfo.vue?vue&type=template&id=a13d31c4&scoped=true"
import script from "./ProfileRemovalInfo.vue?vue&type=script&lang=js"
export * from "./ProfileRemovalInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileRemovalInfo.vue?vue&type=style&index=0&id=a13d31c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13d31c4",
  null
  
)

export default component.exports